module.exports = __webpack_public_path__ + "img/cloud-bg3.aae8b988.png";